import {Query} from "react-apollo";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import React from "react";

let grades = [];

export default class Grades extends React.Component{


  render() {
    return (
      <Query query={this.props.service} fetchPolicy={"network-only"}
        variables={this.props.variables}
        onError={(error) => {
          grades = [];
          console.log("error")
        }}

      >
        {({loading, error, data}) => {
          if (loading) {
            return (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>);
          }
          else if (data) {
            grades = [];
            for (const index in data[this.props.index]) {
              grades.push({
                label: data[this.props.index][index].description,
                value: data[this.props.index][index]
              });
            }
            return (
              <div>
                <label>Grado de Inscripción</label>
                <Select options={grades}
                  value={this.props.grade}
                  onChange={e => this.props.handleChange(e, 'grade')}
                />
              </div>
            )
          }
          else {
            return ( <div>
              <label>Grado de Inscripción</label>
              <Select/>
            </div>)
          }
        }}
      </Query>
    )
  }
}
